import { IHttpService, IPromise } from 'angular';
import HttpService from '../../common/services/http.service';

/* @ngInject */
export class OtpService {
  constructor(
    private $http: IHttpService,
    private httpService: HttpService,
    private config
  ) {}

  public sendOTP(msisdn: string): IPromise<boolean> {
    return this.httpService.extractResponseResult(
      this.$http.post('hafifmuzik/mobile/otp/send', {
        msisdn,
        type: 'updateMsisdn'
      })
    );
  }

  public validateOTP(msisdn: string, smsCode: string): IPromise<boolean> {
    return this.httpService.extractResponseResult(
      this.$http.post('hafifmuzik/mobile/otp/validate', {
        msisdn,
        type: 'updateMsisdn',
        smsCode
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/services/otp.service.ts